export const setNavMenus = (state, version) => {
    state.setAppVersionName = version
}
export const setUserInfo = (state, data) => {
    state.userInfo = data
}
export const setSubuserInfo = (state, data) => {
    state.subuserInfo = data
}
export const setItemsInfoCart = (state, data) => {
    state.getCartDetails = data
}
export const setCustomerNo = (state, data) => {
    state.getCustomerNumber = data
}
export const setPageName = (state, data) => {
    state.pageNameProduct = data
}
export const setAutoRenewItem = (state, data) => {
    state.AutoRenewItem = data
}
export const setSubscriberDetails = (state, data) => {
    state.SubscriberDetails = data
}
export const setItemsCheckoutCart = (state, data) => {
    state.getCheckoutDetails = data
}
export const setSideNavInfo = (state, data) => {
    state.getSideNavInfoDetails = data
}
export const setReportQueueing = (state, data) => {
    state.ReportQueueing = data
}
export const setInvoiceCartDetails = (state, data) => {
    state.invoiceCartDetails = data
}
export const setSideNav = (state, data) => {
    state.sideNav = data
}
export const setCustomerEnterId = (state, data) => {
    state.customerEnteredId = data
}
export const setUniqueCustomerId = (state, data) => {
    state.uniqueCustomerId = data
}
export const setShowAllModule = (state, data) => {
    state.showAllModule = data
}
export const setOTTVerifiedUsers = (state, data) => {
    state.ottVerifiedUsers= data
}
export const setChangeBasePackDetails = (state, data) => {
    state.changeBasePack= data
}
export const setChangeValidityPackDetails = (state, data) => {
    state.changeValidity= data
}
export const setSmsTemplate = (state,data) => {
    state.SMSTemplates = data
}
export const setVerifiedBroadbandCustomer = (state,data) => {
    state.verifiedBroadbandCustomer = data
}
export const setSiteKey = (state,data) => {
    state.sitekey = data
}



// WEBPACK FOOTER //
// ./src/store/mutations.js